"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceInfoFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.SpaceInfoFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("g", { clipPath: "url(#clip0_4049_1540)" },
                react_1.default.createElement("path", { opacity: "0.2", d: "M31.9985 63.9985C49.6716 63.9985 63.9985 49.6716 63.9985 31.9985C63.9985 14.3254 49.6716 -0.00146484 31.9985 -0.00146484C14.3254 -0.00146484 -0.00146484 14.3254 -0.00146484 31.9985C-0.00146484 49.6716 14.3254 63.9985 31.9985 63.9985Z", fill: "#7B67EE" }),
                react_1.default.createElement("path", { d: "M32.5022 50.6654C42.5339 50.6654 50.6654 42.5328 50.6654 32.5022C50.6654 28.2896 49.232 24.4139 46.8251 21.332L44.6702 24.2099C38.8576 31.9702 31.9691 38.859 24.2099 44.6702L21.332 46.8251C24.4128 49.231 28.2907 50.6654 32.5022 50.6654Z", fill: "#CEC5FF" }),
                react_1.default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M41.6072 16.3714C38.7224 14.4511 35.2587 13.332 31.5344 13.332C21.4811 13.332 13.332 21.4825 13.332 31.535C13.332 35.2606 14.4512 38.7248 16.3708 41.608L15.6012 42.1784C14.5298 42.9723 14.4143 44.5331 15.3573 45.476C16.1222 46.2408 17.3318 46.3304 18.2008 45.6864L22.8011 42.2774C30.2171 36.7816 36.7795 30.2192 42.2752 22.8032L45.6843 18.2029C46.3283 17.3338 46.239 16.1242 45.4742 15.3594C44.531 14.4164 42.9704 14.5318 42.1763 15.6032L41.6072 16.3714ZM35.9987 20.6654C35.9987 21.7699 35.1032 22.6654 33.9987 22.6654C32.8942 22.6654 31.9987 21.7699 31.9987 20.6654C31.9987 19.5608 32.8942 18.6654 33.9987 18.6654C35.1032 18.6654 35.9987 19.5608 35.9987 20.6654Z", fill: "#7B67EE" })),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("clipPath", { id: "clip0_4049_1540" },
                    react_1.default.createElement("rect", { width: "64", height: "64", fill: "white" }))));
    },
    name: 'space_info_filled',
    defaultColors: ['#7B67EE', '#CEC5FF', 'white'],
    colorful: true,
    allPathData: [],
    width: '64',
    height: '64',
    viewBox: '0 0 64 64',
});
